module.exports = __webpack_public_path__ + "static/img/img-main-try-logo@2x.e830603.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footer/img-main-try-logo@2x.png
// module id = kgMw
// module chunks = 18